import { gql } from "@apollo/client";

export const fragments = {
  productOverview: gql`
    fragment ProductOverviewFragment on Product {
      id
      slug
      title
      view_count
      favorite_count
      is_in_showroom
      showroom_zone
      quality
      state
      categories {
        slug
      }
      attributes {
        ... on Material {
          slug
        }
        ... on Style {
          slug
        }
      }
      buy_now_price {
        amount
        currency
      }
      original_price {
        amount
        currency
      }
      images {
        id
        url
        large_url: url(size: LG)
        medium_url: url(size: MD)
        small_url: url(size: SM)
        x_small_url: url(size: XS)
        position
        background_color
        width
        height
      }
      image {
        id
        url
        large_url: url(size: LG)
        medium_url: url(size: MD)
        small_url: url(size: SM)
        x_small_url: url(size: XS)
        position
        background_color
        width
        height
      }
      auction {
        id
        state
        allow_bid
        allow_buy_now
        bid_count
        minimum_bid {
          amount
          currency
        }
        buy_now_price {
          amount
          currency
        }
        sold_at {
          amount
          currency
        }
      }
      last_boost
      number_of_items
      attributes {
        ... on Artist {
          id
          title
        }
        ... on Brand {
          id
          title
          description
        }
        ... on Color {
          id
          title
          slug
          hex
        }
        ... on Subject {
          id
          title
          slug
        }
        ... on Designer {
          id
          title
        }
        ... on Label {
          id
          title
          color: hex
          slug
        }
        ... on Material {
          id
          title
          slug
        }
        ... on Style {
          id
          title
          slug
        }
        ... on UsageSign {
          id
          title
          slug
        }
        ... on AdditionalInfo {
          id
          title
          slug
        }
      }
      favorite {
        id
      }
    }
  `,
  product: gql`
    fragment ProductFragment on Product {
      id
      slug
      identifier
      title
      art_orientation
      art_size
      description
      state
      status
      view_count
      favorite_count
      is_in_showroom
      showroom_zone
      quality
      buy_now_price {
        amount
        currency
      }
      brand_suggestion
      last_boost
      isBoosted
      number_of_items
      original_price {
        amount
        currency
      }
      image {
        id
        url
        width
        height
        large_url: url(size: LG)
        medium_url: url(size: MD)
        small_url: url(size: SM)
        x_small_url: url(size: XS)
        position
        background_color
        width
        height
      }
      images {
        id
        url
        width
        height
        large_url: url(size: LG)
        medium_url: url(size: MD)
        small_url: url(size: SM)
        x_small_url: url(size: XS)
        position
        background_color
        width
        height
      }
      condition
      quality
      address {
        id
        city
        country
      }
      auction {
        id
        state
        allow_bid
        allow_buy_now
        bid_count
        minimum_bid {
          amount
          currency
        }
        sold_at {
          amount
          currency
        }
        buy_now_price {
          amount
          currency
        }
      }
      custom_shipping_cost {
        currency
        amount
      }
      customShippingPrices {
        country
        price {
          currency
          amount
        }
      }
      delivery_method
      shipping_method {
        id
        title
        slug
        price {
          amount
          currency
        }
      }
      merchant {
        id
        name
        email
        business_name
        expert_seller
        created
        image {
          url
          id
        }
      }
      favorite {
        id
      }
      categories {
        id
        slug
      }
      width
      height
      depth
      seat_height
      weight
      attributes {
        ... on Artist {
          id
          title
        }
        ... on Brand {
          id
          title
          description
          slug
        }
        ... on Color {
          id
          title
          slug
          hex
        }
        ... on Subject {
          id
          title
          slug
        }
        ... on Designer {
          id
          title
        }
        ... on Label {
          id
          title
          color: hex
          slug
        }
        ... on Material {
          id
          title
          slug
        }
        ... on Style {
          id
          title
          slug
        }
        ... on UsageSign {
          id
          title
          slug
        }
        ... on AdditionalInfo {
          id
          title
          slug
        }
      }
      product_type {
        android_arobject: arobject(platform: ANDROID) {
          id
          url
          platform
        }
        ios_arobject: arobject(platform: IOS) {
          id
          url
          platform
        }
      }
    }
  `,
  pagination: gql`
    fragment PaginationFragment on PaginationResult {
      page
      pages
      limit
      count
    }
  `,
};

// eslint-disable-next-line import/prefer-default-export
export const SEARCH = gql`
  query Search(
    $page: Int = 1
    $type: SearchType = PRODUCT
    $query: String = ""
    $filter: SearchFilterInput
    $sort: SearchSort
    $order: Ordering
  ) {
    search(
      type: $type
      query: $query
      filter: $filter
      sort: $sort
      order: $order
      pagination: { page: $page, limit: 24 }
      exact: true
    ) {
      pagination {
        ...PaginationFragment
      }
      items {
        ...ProductOverviewFragment
      }
    }
  }
  ${fragments.productOverview}
  ${fragments.pagination}
`;

export const GET_PRODUCTS_BY = gql`
  query GetProductsBy($key: ProductFilterKey!, $value: String!) {
    products(filters: { key: $key, value: $value }) {
      items {
        ...ProductFragment
      }
    }
  }
  ${fragments.product}
`;
